import React from 'react';
import { Tooltip, colors } from '@cimpress/react-components';
import IconAlertTriangle from '@cimpress-technology/react-streamline-icons/lib/IconAlertTriangle';

const stateLabels = {
  WaitingForMemsource: 'Waiting for Memsource',
  Translated: 'Translated',
  PartiallyTranslated: 'Partially Translated',
  Imported: 'Imported',
};

export const TranslationBatchState = ({ state, missingCultures }) => {
  const isPartial = state === 'PartiallyTranslated';
  const hasMissingCultures = isPartial && Array.isArray(missingCultures) && missingCultures.length > 0;

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
      {stateLabels[state] ?? state}
      {hasMissingCultures && (
        <Tooltip contents={`Missing cultures: ${missingCultures.join(', ')}`} style={{ marginLeft: 6 }}>
          <span role="img" aria-label={`Missing cultures: ${missingCultures.join(', ')}`}>
            <IconAlertTriangle color={colors.warning.darkest} size="lg" aria-hidden="true" />
          </span>
        </Tooltip>
      )}
    </span>
  );
};
